import { supabase } from '@/lib/supabaseClient';

export interface AutomationPauseState {
  paused: boolean;
  pausedAt: string | null;
  pausedBy: string | null;
}

export const automationPauseService = {
  async getState(tenantId: string): Promise<AutomationPauseState> {
    const { data, error } = await supabase
      .from('tenants')
      .select('automations_paused, automations_paused_at, automations_paused_by')
      .eq('tenant_id', tenantId)
      .single();

    if (error) {
      console.error('Failed to load automation pause state:', error);
      throw new Error('Unable to load automation pause state.');
    }

    return {
      paused: !!data?.automations_paused,
      pausedAt: data?.automations_paused_at ?? null,
      pausedBy: data?.automations_paused_by ?? null,
    };
  },

  async pause(tenantId: string): Promise<AutomationPauseState> {
    const { error } = await supabase.rpc('pause_tenant_automations', {
      p_tenant_id: tenantId,
    });

    if (error) {
      console.error('Failed to pause automations:', error);
      throw new Error('Unable to pause automations. Please try again.');
    }

    return this.getState(tenantId);
  },

  async unpause(tenantId: string): Promise<AutomationPauseState> {
    const { error } = await supabase.rpc('unpause_tenant_automations', {
      p_tenant_id: tenantId,
    });

    if (error) {
      console.error('Failed to resume automations:', error);
      throw new Error('Unable to resume automations. Please try again.');
    }

    return this.getState(tenantId);
  },
};
